// Generated by scripts/write-cascadia-replay-fixtures.ts.
// Do not edit manually.

import type { CascadiaReplayEventType } from "./event-adapter";

export interface CascadiaReplayFixturePlayer {
  readonly id: string;
  readonly name: string;
  readonly role: "host" | "player";
}

export interface CascadiaReplayFixtureEvent {
  readonly sequenceNumber: number;
  readonly eventType: CascadiaReplayEventType;
  readonly userId: string;
  readonly payload: Record<string, unknown>;
}

export interface CascadiaReplayFixture {
  readonly schemaVersion: 1;
  readonly gameType: "cascadia";
  readonly scenario: string;
  readonly source: "generated";
  readonly capturedAt: string;
  readonly players: readonly CascadiaReplayFixturePlayer[];
  readonly events: readonly CascadiaReplayFixtureEvent[];
  readonly notes: readonly string[];
}

export const CASCADIA_REPLAY_FIXTURES: Record<string, CascadiaReplayFixture> = {
  "simple-2p-live": {
    schemaVersion: 1,
    gameType: "cascadia",
    scenario: "simple-2p-live",
    source: "generated",
    capturedAt: "2026-06-08T00:00:00.000Z",
    players: [
      {
        id: "p1",
        name: "Una",
        role: "host",
      },
      {
        id: "p2",
        name: "Bo",
        role: "player",
      },
    ],
    events: [
      {
        sequenceNumber: 1,
        eventType: "init",
        userId: "p1",
        payload: {
          state: {
            gameId: "simple-2p-live",
            version: 0,
            createdAt: "2026-06-08T00:00:00.000Z",
            ruleset: {
              mode: "base",
              modules: {
                landmarks: false,
                ksWildlifePromo: false,
                landmarksKsPromo: false,
                solo: false,
                familyVariant: false,
                intermediateVariant: false,
                familySkipMajority: false,
                fastGame: false,
              },
              playerCount: 2,
              tileOrientation: "pointy-top",
            },
            players: [
              {
                playerId: "p1",
                seat: 0,
                displayName: "Una",
                natureTokens: 0,
                board: {
                  cells: {
                    "0,0": {
                      tileInstanceId: "starter-0-0",
                      tileDefId: "tile_start01_key",
                      rotation: 0,
                      wildlife: null,
                      landmark: null,
                    },
                    "0,1": {
                      tileInstanceId: "starter-0-1",
                      tileDefId: "tile_start01_d5",
                      rotation: 4,
                      wildlife: null,
                      landmark: null,
                    },
                    "-1,1": {
                      tileInstanceId: "starter-0-2",
                      tileDefId: "tile_start01_d7",
                      rotation: 0,
                      wildlife: null,
                      landmark: null,
                    },
                  },
                },
                landmarkPicks: [],
                draft: {
                  tileInstanceId: null,
                  tokenInstanceId: null,
                },
                scoreBreakdown: null,
              },
              {
                playerId: "p2",
                seat: 1,
                displayName: "Bo",
                natureTokens: 0,
                board: {
                  cells: {
                    "0,0": {
                      tileInstanceId: "starter-1-0",
                      tileDefId: "tile_start04_key",
                      rotation: 0,
                      wildlife: null,
                      landmark: null,
                    },
                    "0,1": {
                      tileInstanceId: "starter-1-1",
                      tileDefId: "tile_start04_d5",
                      rotation: 4,
                      wildlife: null,
                      landmark: null,
                    },
                    "-1,1": {
                      tileInstanceId: "starter-1-2",
                      tileDefId: "tile_start04_d7",
                      rotation: 0,
                      wildlife: null,
                      landmark: null,
                    },
                  },
                },
                landmarkPicks: [],
                draft: {
                  tileInstanceId: null,
                  tokenInstanceId: null,
                },
                scoreBreakdown: null,
              },
            ],
            market: {
              slots: [
                {
                  index: 0,
                  tileInstanceId: "tile-inst-18",
                  tokenInstanceId: "token-inst-64",
                  tileDefId: "tile_start02_d5",
                  wildlifeSpecies: "fox",
                },
                {
                  index: 1,
                  tileInstanceId: "tile-inst-42",
                  tokenInstanceId: "token-inst-44",
                  tileDefId: "tile_prairie_mountain_split_elk_fox",
                  wildlifeSpecies: "fox",
                },
                {
                  index: 2,
                  tileInstanceId: "tile-inst-30",
                  tokenInstanceId: "token-inst-21",
                  tileDefId: "tile_forest_keystone_elk",
                  wildlifeSpecies: "elk",
                },
                {
                  index: 3,
                  tileInstanceId: "tile-inst-8",
                  tokenInstanceId: "token-inst-97",
                  tileDefId: "tile_wetland_keystone_bear",
                  wildlifeSpecies: "salmon",
                },
              ],
              autoWipePending: false,
              optionalWipeUsedThisTurn: false,
              decoupleUnlockedThisTurn: false,
            },
            supply: {
              habitatDrawPile: [
                "tile-inst-12",
                "tile-inst-20",
                "tile-inst-10",
                "tile-inst-24",
                "tile-inst-27",
                "tile-inst-1",
                "tile-inst-21",
                "tile-inst-37",
                "tile-inst-4",
                "tile-inst-15",
                "tile-inst-41",
                "tile-inst-9",
                "tile-inst-25",
                "tile-inst-11",
                "tile-inst-29",
                "tile-inst-36",
                "tile-inst-31",
                "tile-inst-22",
                "tile-inst-32",
                "tile-inst-39",
                "tile-inst-2",
                "tile-inst-13",
                "tile-inst-19",
                "tile-inst-40",
                "tile-inst-3",
                "tile-inst-28",
                "tile-inst-7",
                "tile-inst-5",
                "tile-inst-33",
                "tile-inst-35",
                "tile-inst-23",
                "tile-inst-16",
                "tile-inst-34",
                "tile-inst-38",
                "tile-inst-14",
                "tile-inst-17",
                "tile-inst-26",
                "tile-inst-6",
                "tile-inst-0",
              ],
              wildlifeBag: [
                "token-inst-99",
                "token-inst-19",
                "token-inst-76",
                "token-inst-8",
                "token-inst-10",
                "token-inst-26",
                "token-inst-25",
                "token-inst-27",
                "token-inst-35",
                "token-inst-60",
                "token-inst-89",
                "token-inst-6",
                "token-inst-28",
                "token-inst-39",
                "token-inst-94",
                "token-inst-59",
                "token-inst-74",
                "token-inst-90",
                "token-inst-7",
                "token-inst-51",
                "token-inst-96",
                "token-inst-11",
                "token-inst-40",
                "token-inst-15",
                "token-inst-66",
                "token-inst-2",
                "token-inst-48",
                "token-inst-49",
                "token-inst-86",
                "token-inst-4",
                "token-inst-80",
                "token-inst-63",
                "token-inst-68",
                "token-inst-82",
                "token-inst-85",
                "token-inst-93",
                "token-inst-5",
                "token-inst-1",
                "token-inst-36",
                "token-inst-12",
                "token-inst-92",
                "token-inst-57",
                "token-inst-88",
                "token-inst-3",
                "token-inst-14",
                "token-inst-73",
                "token-inst-98",
                "token-inst-30",
                "token-inst-52",
                "token-inst-77",
                "token-inst-67",
                "token-inst-53",
                "token-inst-69",
                "token-inst-72",
                "token-inst-9",
                "token-inst-56",
                "token-inst-84",
                "token-inst-20",
                "token-inst-75",
                "token-inst-55",
                "token-inst-38",
                "token-inst-54",
                "token-inst-91",
                "token-inst-87",
                "token-inst-71",
                "token-inst-42",
                "token-inst-0",
                "token-inst-79",
                "token-inst-41",
                "token-inst-37",
                "token-inst-43",
                "token-inst-65",
                "token-inst-18",
                "token-inst-46",
                "token-inst-47",
                "token-inst-78",
                "token-inst-83",
                "token-inst-32",
                "token-inst-33",
                "token-inst-61",
                "token-inst-81",
                "token-inst-45",
                "token-inst-23",
                "token-inst-95",
                "token-inst-16",
                "token-inst-17",
                "token-inst-29",
                "token-inst-70",
                "token-inst-13",
                "token-inst-58",
                "token-inst-31",
                "token-inst-34",
                "token-inst-22",
                "token-inst-50",
                "token-inst-62",
                "token-inst-24",
              ],
              natureTokenReserve: 25,
            },
            scoringCards: {
              bear: "bear_A",
              elk: "elk_A",
              salmon: "salmon_A",
              hawk: "hawk_A",
              fox: "fox_A",
            },
            turn: {
              activeSeat: 0,
              phase: "marketCheck",
              actionBudget: {
                natureSpendable: 0,
                landmarkEligibleHabitats: [],
                justPlacedTileCoord: null,
              },
            },
            rng: {
              algorithm: "mulberry32",
              seed: "cascadia-replay-simple-2p",
            },
            winners: null,
          },
        },
      },
      {
        sequenceNumber: 2,
        eventType: "DraftPair",
        userId: "p1",
        payload: {
          slot: 0,
          stateVersion: 0,
        },
      },
      {
        sequenceNumber: 3,
        eventType: "PlaceTile",
        userId: "p1",
        payload: {
          coord: {
            q: -1,
            r: 0,
          },
          rotation: 0,
          stateVersion: 1,
        },
      },
      {
        sequenceNumber: 4,
        eventType: "PlaceWildlife",
        userId: "p1",
        payload: {
          coord: {
            q: -1,
            r: 0,
          },
          stateVersion: 2,
        },
      },
      {
        sequenceNumber: 5,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          stateVersion: 3,
        },
      },
      {
        sequenceNumber: 6,
        eventType: "DraftPair",
        userId: "p2",
        payload: {
          slot: 0,
          stateVersion: 4,
        },
      },
      {
        sequenceNumber: 7,
        eventType: "PlaceTile",
        userId: "p2",
        payload: {
          coord: {
            q: -1,
            r: 0,
          },
          rotation: 0,
          stateVersion: 5,
        },
      },
      {
        sequenceNumber: 8,
        eventType: "ReturnWildlife",
        userId: "p2",
        payload: {
          stateVersion: 6,
        },
      },
      {
        sequenceNumber: 9,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          stateVersion: 7,
        },
      },
      {
        sequenceNumber: 10,
        eventType: "DraftPair",
        userId: "p1",
        payload: {
          slot: 0,
          stateVersion: 8,
        },
      },
      {
        sequenceNumber: 11,
        eventType: "PlaceTile",
        userId: "p1",
        payload: {
          coord: {
            q: -1,
            r: -1,
          },
          rotation: 0,
          stateVersion: 9,
        },
      },
      {
        sequenceNumber: 12,
        eventType: "PlaceWildlife",
        userId: "p1",
        payload: {
          coord: {
            q: -1,
            r: -1,
          },
          stateVersion: 10,
        },
      },
      {
        sequenceNumber: 13,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          stateVersion: 11,
        },
      },
    ],
    notes: [
      "Cascadia is a public-information game; replay renders canonical engine state directly (no viewer-state projection).",
      "Fixture: init -> 3 full turns (DraftPair -> PlaceTile -> PlaceWildlife/ReturnWildlife -> EndTurn) alternating the wildlife branch and rotating seats 0->1->0.",
      "Final state: phase marketCheck, activeSeat 1, version 12.",
      "Terminal `scoring` phase + winners are server-computed (ScoreGame) and are not reconstructed by client-side event replay; an end-state fixture is a follow-up.",
    ],
  },
};
